import { Components, Theme } from '@mui/material';

export const MuiTextField: Components<
  Omit<Theme, 'components'>
>['MuiTextField'] = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        '& input:-webkit-autofill': {
          backgroundColor: 'none', // or 'none' depending on your preference
        },
        '& input:-moz-autofill': {
          backgroundColor: 'none',
        },
        '& input:-ms-autofill': {
          backgroundColor: 'none',
        },

        '& .MuiInputAdornment-positionEnd': {
          color: theme.palette.primary.main,
        },
      };
    },
  },
};
